module.exports = __webpack_public_path__ + "static/media/profit_icon.045cb647.png";